import createSvgIcon from "./utils/create_icon"

const HandleSides = createSvgIcon(<><g fill="currentColor"><path d="M5 3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2V7a2 2 0 0 1 2-2h10a2 2 0 0 0-2-2zm9 9.667L14.875 15h-1.75z" /><path clipRule="evenodd" d="M7 9a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2zm8 1 3 8h-2l-.375-1h-3.25L12 18h-2l3-8z" fillRule="evenodd" /></g></>, "HandleSides")
export default HandleSides
